"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrackingInDebugModeVerbose = void 0;
const env_1 = require("../../env");
const QUERY_PARAM = 'tracking_debug';
function isTrackingInDebugMode() {
    if (!(0, env_1.isOnBrowser)()) {
        return false;
    }
    return window.location.search.includes(QUERY_PARAM);
}
exports.default = isTrackingInDebugMode;
function isTrackingInDebugModeVerbose() {
    if (!(0, env_1.isOnBrowser)()) {
        return false;
    }
    return window.location.search.includes(QUERY_PARAM + '=verbose');
}
exports.isTrackingInDebugModeVerbose = isTrackingInDebugModeVerbose;
